<template>
    <div class="global">
        <header class="global-header">
            <div class="line-item">
                <div class="left-item">
                    <div class="el">
                        <h1>
                            <span>Clients</span>
                        </h1>
                    </div>
                </div>
                <div class="right-item">
                    <div class="el popover-container" style="margin: 23px;">
                        <span @click="releaseSettings()">
                            <span class="message-icon unread" style="cursor: pointer; font-family: Arial, Helvetica, sans-serif; font-size: 16px; color: rgb(0, 168, 202);">
                                Version {{ latestVersion }}
                            </span>
                        </span>
                        <span></span>
                    </div>
                    <div class="el">
                        <img @click="showVideoPdf()" class="pencilSelected" src="static/img/Help_Icon-gr.png">
                    </div>
                    <div class="el header-avatar">
                        <md-button class="avatar-button" @click="showCurrentUserProfile()">
                            <md-avatar v-if="currentUser.avatar" class="md-avatar-icon">
                                <img :src="getImageSrc(currentUser.avatar)">
                            </md-avatar>
                            <md-avatar v-else class="md-avatar-icon blue">
                                {{ getUserInitials(currentUser) }}
                            </md-avatar>
                        </md-button>
                    </div>
                    <div class="el">
                        <md-button class="md-icon-button" @click="navToSettings()">
                            <md-icon>settings</md-icon>
                        </md-button>
                    </div>
                    <div class="el logout-button">
                        <md-button @click="clickLogout()">Logout</md-button>
                    </div>
                </div>
            </div>
        </header>
        <section class="page-content">
            <div id="ClientListTab" class="wrap btn-position-wrap">
                <md-list class="clients-wrap">
                    <div class="collapsing-list-item" v-for=" (client, index) in userClients" :id="client.client_id" v-if="userClients != null">
                        <md-list-item class="client-line" @click="navToClient(client)">
                            <div class="left-item">
                                <a class="client-nav">
                                    <h2>{{ client.companyName }}
                                        <small>{{ client.description }}</small>
                                    </h2>
                                </a>
                            </div>
                            <div class="right-item">
                            </div>
                            <md-list slot="md-expand">
                                <md-list-item class="md-inset">
                                    <div class="client-info-wrap line-item">
                                        <div class="right-item">
                                            <div class="el"></div>
                                        </div>
                                    </div>
                                </md-list-item>
                            </md-list>
                        </md-list-item>
                    </div>
                </md-list>
                <modal name="ReleaseModal" :resizable="true" :reset="true" height="60%" width="60%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
                    <div class="row">
                        <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                            <i class="md-icon" style="color: #ffffff !important;">clear</i>
                        </button>
                        <button @click="maxWindowRelease()" type="button" class="minimize-icon">
                            <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important;"/>
                        </button>
                        <button @click="minWindowRelease()" type="button" class="maximize-icon">
                            <i class="md-icon" style="color: #ffffff !important;">minimize</i>
                        </button>
                        <button @click="backList()" v-if="!releasePanel" type="button" class="close md-button md-icon-button backBtn">
                            <i class="md-icon">arrow_back</i>
                        </button>
                    </div>
                    <div>
                        <div class="scroll-cont" v-if="releasePanel">
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="md-dialog-actions full-btn">
                                        <button type="button" class="md-button md-raised md-theme-default Release-list-front redActiveManual">
                                            <div class="fontManualTab">
                                                Version List
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row scroll-cont-wrap">
                                <div class="md-dialog-container" tabindex="-1">
                                    <div class="boxes">
                                        <div id="releseList" class="vedionameList">
                                            <div v-if="releaseData === 0" style="text-align:center">No new version found.</div>
                                            <div v-else v-for="(release, index) in releaseData.release" :key="index">
                                                <p>
                                                    <a style="text-decoration: none !important;" v-on:click="showRelease(release)">
                                                        <span style="padding-left:20px;"><i class="md-icon">settings</i></span> Version {{ release.v_no }}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-cont" v-if="releaseDetailPanel">
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="md-dialog-actions full-btn">
                                        <button type="button" class="md-button md-raised md-theme-default Release-list-front redActiveManual">
                                            <div class="fontManualTab">
                                                Version Detail
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="customScrollWrapper">
                                        <div class="md-dialog-container" tabindex="-1">
                                            <div class="boxes">
                                                <div class="releaseWrapper" id="releseDetail">
                                                    <div class="releaseText"><b>Version No.</b> {{ this.singleReleaseData.v_no }}</div>
                                                    <div class="releaseText"><b>Date.</b> {{ this.singleReleaseData.date }}</div>
                                                </div>
                                                <div id="functionaldescription">
                                                    <div v-for="(releasefunction, index) in this.singleReleaseData.detail" :key="index">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="funcDespWrapper">
                                                                    <div class="dec-left-panel"><b>{{ releasefunction.heading }} :- </b></div>
                                                                    <div class="dec-right-panel"> {{ releasefunction.description }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </modal>
                <modal name="ReleaseModal1" :resizable="true" :reset="true" height="100%" width="100%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
                    <div class="row">
                        <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                            <i class="md-icon" style="color: #ffffff !important;">clear</i>
                        </button>
                        <button @click="maxWindowRelease()" type="button" class="minimize-icon">
                            <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important;"/>
                        </button>
                        <button @click="minWindowRelease()" type="button" class="maximize-icon">
                            <i class="md-icon" style="color: #ffffff !important;">minimize</i>
                        </button>
                        <button @click="backList()" v-if="!releasePanel" type="button" class="close md-button md-icon-button backBtn">
                            <i class="md-icon">arrow_back</i>
                        </button>
                    </div>
                    <div>
                        <div class="scroll-cont" v-if="releasePanel">
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="md-dialog-actions full-btn">
                                        <button type="button" class="md-button md-raised md-theme-default Release-list-front redActiveManual">
                                            <div class="fontManualTab">
                                                Version List
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row scroll-cont-wrap">
                                <div class="md-dialog-container" tabindex="-1">
                                    <div class="boxes">
                                        <div id="releseList" class="vedionameList">
                                            <div v-if="releaseData.release.length === 0" style="text-align:center">No new version found.</div>
                                            <div v-else v-for="(release, index) in releaseData.release" :key="index">
                                                <p>
                                                    <a style="text-decoration: none !important;" v-on:click="showRelease(release)">
                                                        <span style="padding-left:20px;"><i class="md-icon">settings</i></span> Version {{ release.v_no }}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-cont" v-if="releaseDetailPanel">
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="md-dialog-actions full-btn">
                                        <button type="button" class="md-button md-raised md-theme-default Release-list-front redActiveManual">
                                            <div class="fontManualTab">
                                                Version Detail
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 p-0">
                                    <div class="customScrollWrapper fullViewContent">
                                        <div class="md-dialog-container" tabindex="-1">
                                            <div class="boxes">
                                                <div class="releaseWrapper" id="releseDetail">
                                                    <div class="releaseText"><b>Version No.</b> {{ this.singleReleaseData.v_no }}</div>
                                                    <div class="releaseText"><b>Date.</b> {{ this.singleReleaseData.date }}</div>
                                                </div>
                                                <div id="functionaldescription">
                                                    <div v-for="(releasefunction, index) in this.singleReleaseData.detail" :key="index">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="funcDespWrapper">
                                                                    <div class="dec-left-panel"><b>{{ releasefunction.heading }} :- </b></div>
                                                                    <div class="dec-right-panel"> {{ releasefunction.description }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </modal>
            </div>
        </section>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog" style="width: 120%; height: -webkit-fill-available;">
            <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                <i class="md-icon" style="color: #ffffff !important;">clear</i>
            </button>
            <ReleaseSettings clinetVersionCheck="1" :latestVersion='latestVersion'></ReleaseSettings>
        </md-dialog>

        <modal name="hello-world" class="help-modal-small" :resizable="true" :reset="true" height="60%" width="60%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
            <div class="row ">
                <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">clear</i>
                </button>
                <button @click="maxWindow()" type="button" class="minimize-icon">
                    <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important; height: 26px !important;"/>
                </button>
                <button @click="minWindow()" type="button" class="maximize-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">minimize</i>
                </button>
                <button @click="backList()" v-if="!listPanel" type="button" style="left: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close md-button md-icon-button">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">arrow_back</i>
                </button>
            </div>
            <div class="scroll-cont" v-if="listPanel">
                <div class="row">
                    <div class="col-4">
                        <div class="md-dialog-actions">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('homeActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    Video
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('infoActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    PDF
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('faqActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    FAQ
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row scroll-cont-wrap">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" id="home" v-show="isActiveTab('homeActive')">
                            <div id="videoList" class="vedionameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '0'"><a style="text-decoration: none !important;" v-on:click="showVedio(usermanual.id)"> <span style="padding-left:20px;"><i class="md-icon">videocam</i></span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('infoActive')">
                            <div id="pdfList" class="pdfnameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '1'"><a style="text-decoration: none !important;" v-on:click="showPdf(usermanual.id)"> <span style="padding-left:20px;"> <i class="md-icon">picture_as_pdf</i> </span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('faqActive')">
                            <div id="faqList" class="pdfnameList" v-if=showquestion>
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '2'">
                                        <a style="text-decoration: none !important;" class="d-flex-align1" v-on:click="showfaq(usermanual)">
                                            <span>
                                                <img class="pencilSelectedfaq" style="height: 20px;" src="static/img/Help_Icon-gr.png">
                                            </span>
                                            {{ usermanual.question }}
                                        </a>
                                        </p>
                                    <p v-if="isHidden">{{ usermanual.answers }}</p>
                                </div>
                            </div>
                            <div id="faqList" class="pdfnameList" v-if=showquestiondetail>
                                <p>
                                    <a class="d-flex-align1" style="text-decoration: none !important;" v-on:click="showfaqs(usermanual)">
                                        <span>
                                            <md-icon class="faq-section-back-button" style="padding-right:15px">arrow_back</md-icon>
                                            <img class="pencilSelectedfaq" style="height: 20px;" src="static/img/Help_Icon-gr.png">
                                        </span>
                                        {{ this.detailinfo.question }}
                                    </a>
                                </p>
                                <div class="d-flex">
                                <span><img class="pencilSelectedfaq" src="static/img/bulbicon.jpg" style="height: 20px;"></span> <p style="text-decoration: none !important; margin-left: 0px;" class="d-flex-align1">{{ this.detailinfo.answers }}</p></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="logout-button conatinerForSupport">
                    <a href="https://www.listentech.com/listen-navilution-support/" target="_blank" class="GFG">
                        <button class="md-button md-theme-default" style="margin-bottom:10px; padding:10px;">
                            Website support
                        </button>
                    </a>
                    <md-button v-bind:href=" 'mailto:' + supportEmail" class="md-button md-theme-default">
                        Email support
                    </md-button>
                </div>
            </div>
            <div v-if="vedioPanel">
                <div class="row">
                    <div class="col-12">
                        <div data-v-ec680dbc="" class="md-dialog-actions ">
                            <button data-v-ec680dbc="" type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">Video</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pdfPanel">
                <div class="row">
                    <div class="col-12">
                        <div class="md-dialog-actions ">
                            <button type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">PDF</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <embed v-bind:src="this.pdfSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="hello-world2" class="help-modal-large" :resizable="true" :reset="true" height="100%" width="100%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
            <div class="row ">
                <button @click="closeshowVideoPdf()" type="button" style="right: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">clear</i>
                </button>
                <button @click="maxWindow()" type="button" class="minimize-icon">
                    <img src="static/img/max1.png" class="md-icon" style="color: #ffffff !important; height: 26px !important;"/>
                </button>
                <button @click="minWindow()" type="button" class="maximize-icon">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">minimize</i>
                </button>
                <button @click="backList()" v-if="!listPanel" type="button" style="left: 0; position: absolute; z-index: 9999; cursor: pointer; top: 0;" class="close md-button md-icon-button">
                    <i class="md-icon" style="color: #ffffff !important; height: 26px !important;">arrow_back</i>
                </button>
            </div>
            <div class="scroll-cont" v-if="listPanel">
                <div class="row">
                    <div class="col-4">
                        <div class="md-dialog-actions ">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('homeActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    Video
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('infoActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    PDF
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="md-dialog-actions full-btn">
                            <button v-bind:class="{redActiveManual}" type="button" v-on:click="makeActive('faqActive')" class="md-button md-raised md-theme-default Usemanual-list-front">
                                <div v-bind:class="{fontManualTab}">
                                    FAQ
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row scroll-cont-wrap">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" id="home" v-show="isActiveTab('homeActive')">
                            <div id="videoList" class="vedionameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '0'"><a class="d-flex" style="text-decoration: none !important;" v-on:click="showVedio(usermanual.id)"> <span style="padding-left:0px; padding-right:7.6px;"><i class="md-icon">videocam</i></span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('infoActive')">
                            <div id="pdfList" class="pdfnameList">
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '1'"><a class="d-flex" style="text-decoration: none !important;" v-on:click="showPdf(usermanual.id)"> <span style="padding-left:0px; padding-right:7.6px;"> <i class="md-icon">picture_as_pdf</i> </span> {{ usermanual.attachment_name }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="boxes" id="info" v-show="isActiveTab('faqActive')">
                            <div id="faqList" class="pdfnameList" v-if=showquestion>
                                <div v-if="UserManualList.length==0" style="text-align:center">No file found.</div>
                                <div v-else v-for="(usermanual, index) in UserManualList" :key="usermanual.id">
                                    <p v-if="usermanual.type == '2'">
                                        <a style="text-decoration: none !important;" class="d-flex" v-on:click="showfaq(usermanual)">
                                            <img class="pencilSelectedfaq" style="height: 20px; padding-left:0px; padding-right:7.6px;" src="static/img/Help_Icon-gr.png">
                                            {{ usermanual.question }}
                                        </a>
                                    <p v-if="isHidden">{{ usermanual.answers }}</p>
                                </div>
                            </div>
                            <div id="faqList" class="pdfnameList" v-if=showquestiondetail>
                                <p>
                                    <a class="d-flex" style="text-decoration: none !important;" v-on:click="showfaqs(usermanual)">
                                        <span style="padding-left:0px; padding-right:7.6px;">
                                            <md-icon class="faq-section-back-button">arrow_back</md-icon>
                                            <img class="pencilSelectedfaq" style="height: 20px; padding-left:0px; padding-right:7.6px;" src="static/img/Help_Icon-gr.png">
                                        </span>
                                        {{ this.detailinfo.question }}
                                    </a>
                                </p>
                                <p class="d-flex-align1" style="text-decoration: none !important; ">

                                    <span><img class="pencilSelectedfaq" src="static/img/bulbicon.jpg" style="height: 20px;"></span>
                                    {{ this.detailinfo.answers }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="logout-button conatinerForSupport">
                    <a href="https://www.listentech.com/listen-navilution-support/" target="_blank" class="GFG">
                        <button class="md-button md-theme-default" style="margin-bottom:10px; padding:10px;">
                            Website support
                        </button>
                    </a>
                    <md-button v-bind:href=" 'mailto:' + supportEmail" class="md-button md-theme-default">
                        Email support
                    </md-button>
                </div>
            </div>
            <div v-if="vedioPanel">
                <div class="row">
                    <div class="col-12">
                        <div data-v-ec680dbc="" class="md-dialog-actions ">
                            <button data-v-ec680dbc="" type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">Video</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pdfPanel">
                <div class="row">
                    <div class="col-12">
                        <div class="md-dialog-actions full-btn">
                            <button type="button" style="background-color: #00A8CA;width:100%; height:62px;" v-on:click="makeActive('homeActive')" class="md-button md-raised md-primary md-theme-default">
                                <div class="md-ripple">
                                    <span class="md-button-content">Version</span> <!---->
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="md-dialog-container" tabindex="-1">
                        <div class="boxes" tabindex="-1">
                            <embed v-bind:src="this.pdfSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                        </div>
                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import {lastReleaselist} from '../../services/ReleaseService.js';
import {logout} from '../../services/LoginService';
import {checkReleaseExist, getUserManual, releaseStatusUpdate} from '../../services/ClientService.js';

import ReleaseSettings from './ReleaseSettings.vue';
import axios from 'axios';

export default {
  data () {
    return {
      showDeleteDialog: false,
      msgStatus: false,
      errorMessage: null,
      userClients: [],
      latestVersion: '',
      releaseData: '',
      releasePanel: true,
      isHidden: false,
      releaseDetailPanel: false,
      listPanel: true,
      vedioPanel: false,
      pdfPanel: false,
      faqPanel: false,
      showquestion: true,
      showquestiondetail: false,
      UserManualList: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      UserManualListfaq: [{
        id: '',
        attachment_name: '',
        question: '',
        answers: '',
        type: '',
        path: ''
      }],
      supportEmail: 'support@listentech.com',
      webSiteSupport: 'https://www.listentech.com/support/',
      activeTab: 'homeActive',
      choice: 'homeActive'
    };
  },
  components: {
    ReleaseSettings
  },
  computed: {
    ...mapState({
      routerPathName: state => state.RouterModule.name
    }),
    ...mapGetters('user', ['isAdmin', 'clientId', 'currentUser']),
    ...mapGetters('client', ['currentClientName', 'currentClient', 'clientList', 'clientLoaded']),
    creatingNewClient () {
      return this.routerPathName === 'NewClient';
    }
  },
  created () {
    this.checkReleaseExistFunction();
  },
  methods: {
    ...mapActions('client', ['loadClient', 'resetClient', 'toggleClientLoadedFlag', 'unloadClient']),
    ...mapActions('user', ['updateUserClientData', 'setUserToEdit', 'signOutUser']),
    ...mapActions('tours', ['clearCurrentTour']),
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    backList () {
      console.log('rajesh srivastav');
      this.releaseDetailPanel = false;
      this.releasePanel = true;
    },
    async checkReleaseExistFunction () {
      var response = await checkReleaseExist(this.currentUser.id);
      this.releaseData = response.data;
    },
    async showRelease (releaseDataDetail) {
      this.releasePanel = false;
      this.releaseDetailPanel = true;
      this.singleReleaseData = releaseDataDetail;
      var newData = {
        r_id: releaseDataDetail.id,
        u_id: this.currentUser.id
      };
      await releaseStatusUpdate(newData);
    },
    releaseSettings () {
      this.$router.push('/settings/release');
    },
    versionDetails () {
      this.showDeleteDialog = true;
      console.log('version click');
    },
    /* closeshowVideoPdf () {
          this.showDeleteDialog = false;
          this.releasePanel = true;
          this.releaseDetailPanel = false;
          this.singleReleaseData = '';
          this.$modal.hide('ReleaseModal');
          this.$modal.hide('ReleaseModal1');
        }, */
    closeshowVideoPdf () {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    maxWindowRelease () {
      this.$modal.hide('ReleaseModal');
      this.$modal.show('ReleaseModal1');
    },
    minWindowRelease () {
      this.$modal.show('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    maxWindow () {
      this.$modal.hide('hello-world');
      this.$modal.show('hello-world2');
    },
    minWindow () {
      this.$modal.show('hello-world');
      this.$modal.hide('hello-world2');
    },
    getUserInitials (user) {
      let userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    async navToClient (client) {
      var clientIDForBoth;
      if (client.clientId) {
        clientIDForBoth = client.clientId;
      } else {
        clientIDForBoth = client.client_id;
      }
      await this.updateUserClient(this.currentUser.id, clientIDForBoth);
      await this.loadClient({isAdmin: false, clientId: clientIDForBoth});
      await this.updateUserClientData({id: this.currentUser.id});
      this.$router.push('/client/tours');
    },
    navToClientList () {
      this.resetClient();
      this.$router.push({path: '/client/list'});
    },
    toggleClientLoaded () {
      this.toggleClientLoadedFlag();
    },
    navToSettings () {
      if (this.isAdmin) {
        this.$router.push('/settings/general');
      } else {
        this.$router.push('/settings/users');
      }
    },
    showCurrentUserProfile () {
      this.setUserToEdit(this.currentUser);
      this.$router.push('/user');
    },
    clickLogout () {
      logout(this.currentUser.id);
      this.signOutUser();
      this.$router.push('/login');
    },
    getUserClientList (userId) {
      return axios.get('api/users/clients/' + userId);
    },
    updateUserClient (userId, clientId) {
      return axios.get('api/users/updateclient/' + userId + '/' + clientId);
    },
    async showVideoPdf () {
      this.$modal.show('hello-world');
      var result = await getUserManual();
      this.UserManualList = result.data;
      this.vedioPanel = false;
      this.pdfPanel = false;
    },
    closeshowfaq () {
      this.vedioPanel = false;
      this.pdfPanel = false;
      this.listPanel = true;
      this.showVideoPdfModal = false;
      this.$modal.hide('hello-world');
      this.$modal.hide('hello-world2');
      this.releasePanel = true;
      this.releaseDetailPanel = false;
      this.singleReleaseData = '';
      this.$modal.hide('ReleaseModal');
      this.$modal.hide('ReleaseModal1');
    },
    showVedio (id) {
      window.open('#/usermanual/video?' + id, '_blank');
    },
    showPdf (id) {
      window.open('#/usermanual/pdf?' + id, '_blank');
    },
    showfaq (detailfaq) {
      this.showquestion = false;
      this.showquestiondetail = true;
      this.detailinfo = detailfaq;
    },
    showfaqs (detailfaq) {
      this.showquestion = true;
      this.showquestiondetail = false;
      this.detailinfo = detailfaq;
    },
    isActiveTab: function (val) {
      return this.choice === val;
    },
    makeActive: function (val) {
      if (val === 'homeActive' && this.activeTab !== 'homeActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'homeActive';
      }
      if (val === 'infoActive' && this.activeTab !== 'infoActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'infoActive';
      }
      if (val === 'faqActive' && this.activeTab !== 'faqActive') {
        this.isActive = !this.isActive;
        this.activeTab = 'faqActive';
      }
      this.choice = val;
      console.log('this.activeTab', this.activeTab);
      console.log('this.choice', this.choice);
    }
  },
  async mounted () {
    let latestThis = this;
    lastReleaselist().then(function (defs) {
      latestThis.latestVersion = defs.data[0].v_no;
    });
    try {
      if (!this.errorMessage) {
        this.errorMessage = null;
      }
      if (!this.clientLoaded) {
        if (this.isAdmin === 0) {
          await this.loadClient({isAdmin: false, clientId: this.clientId});
          this.toggleClientLoaded();
          this.$router.push('/clients/switch');
        } else {
          this.toggleClientLoaded();
          this.navToClientList();
        }
      }
      let result = await this.getUserClientList(this.currentUser.id);
      this.userClients = result.data;
    } catch (err) {
      console.error('Could not load client(s).', err);
      this.errorMessage = 'System error:  could not load content';
    }
  }
};
</script>

<style type="scss" scoped>
.maxmize {
    width: 1000px !important;
}

/* This fixes Vue Material's application of md-button-clean to md-list-item tags in render */
body {
    background: #f00;
}

.md-list-item .md-button-clean {
    text-transform: none !important;
}

.md-tabs-navigation a.md-button {
    padding-left: 48px !important;
    padding-right: 48px !important;
    font-weight: 400 !important;
    font-size: 14px !important;
}

.md-tabs-indicator {
    height: 3px !important;
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

.header-avatar .md-button {
    top: 13px;
    height: 40px;
    width: 40px;
    min-width: 40px !important;
    margin: 0;
}

hr {
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    color: #e0e0e0 !important;
}

.avatar-button {
    font-weight: 300 !important;
}

.logout-button {
    padding-top: 13.5px;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.v--modal-overlay .v--modal-box {
    height: 1050px !important;
    width: 900px !important;
}

.v--modal-background-click .v--modal-box .v--modal {
    height: auto !important;

}

div#home {
    margin: 0 auto;
    width: 96%;
}

.md-dialog-actions {
    padding: 0px 0px 0px 1px !important;
}

.v--modal-box.v--modal .col-6 {
    padding: 0 !important;
}

.v--modal-overlay .v--modal-box {
    position: relative;
    box-sizing: border-box;
    top: 0px;
    left: 383px;
    width: 800px;
    height: 900px;
}

.pencilSelected {
    width: auto;
    cursor: pointer;
    margin-top: 19px;
    max-width: 29px;
    margin-right: 23px;
}

.pencilSelectedfaq {
    width: auto;
    cursor: pointer;
    margin-top: 1px;
    margin-right: 26px;
}

.vedionameList {
    padding-left: 4% !important;
    padding-top: 10px;
}

.pdfnameList {
    padding-left: 6%;
    padding-top: 10px;
}

.Usemanual-list-front {
    width: 100%;
    height: 62px;
}

.Release-list-front {
    width: 100%;
    height: 62px;
}

.redActiveManual {
    border-bottom: 3px solid #08a8ca;
}

.fontManualTab {
    color: #08a8ca;
}

.close-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 0px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.minimize-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 37px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.maximize-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 74px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.scroll-cont {
    height: 100%;
    padding: 0 24px;
}

.scroll-cont-wrap {
    max-height: calc(100% - 62px);
    overflow: auto;
}

.p-0 {
    padding: 0 !important;
}

.releaseWrapper {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.funcDespWrapper {
    display: flex;
    padding: 15px;
}

.dec-left-panel {
    display: flex;
    flex: 0 0 25%;
    flex-wrap: wrap;
}

.dec-right-panel {
    display: flex;
    flex: 0 0 75%;
    flex-wrap: wrap;
}

.customScrollWrapper {
    width: 100%;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 320px;
    height: 100%;
}

.customScrollWrapper.fullViewContent {
    max-height: calc(100vh - 60px);
}

.backBtn {
    left: 0px;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
    top: 0px;
    color: #00788A !important;
    opacity: 1;
}

.popover-container {
    position: relative;
}

.popover-main {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    background: rgba(0, 0, 0, 0.8);
    padding: 15px;
    border-radius: 3px;
    color: #fff;
    font-size: 13px;
    z-index: 9;
}

.message-button:hover {
    color: transparent;
}

.message-button .message-icon i {
    color: #fff;
    border-radius: 50%;
    width: 29px;
    height: 29px;
    font-size: 18px !important;
}

.message-button .message-icon.unread i {
    background: red;
}

.message-button .message-icon.read i {
    background: #707070;
}

.scroll-cont-wrap {
    border-bottom: 1px solid #e2e2e2;

}

.conatinerForSupport {
    position: absolute;
    bottom: 0;
}

.close-icon {
    background-color: #00A8CA;
    border: none;
    position: relative;
    right: 0px !important;
    top: 0px !important;
    position: absolute;
    z-index: 9999;
    cursor: pointer;
}

.row.mt-40.version-table {
    overflow-y: scroll;
    height: 400px;
}

/* This fixes Vue Material's application of md-button-clean to md-list-item tags in render */
.md-list-item .md-button-clean {
    text-transform: none !important;
}

.md-tabs-navigation a.md-button {
    padding-left: 48px !important;
    padding-right: 48px !important;
    font-weight: 400 !important;
    font-size: 14px !important;
}

.md-tabs-indicator {
    height: 3px !important;
    /*background-color: rgb(0,168,202) !important;*/
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

.header-avatar .md-button {
    top: 13px;
    height: 40px;
    width: 40px;
    min-width: 40px !important;
    margin: 0;
}

hr {
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    color: #e0e0e0 !important;
}

.avatar-button {
    font-weight: 300 !important;
}

.logout-button {
    padding-top: 13.5px;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.d-flex-align1 span {
    width: 40px;
    padding-right: 15px;
}

.faq-section-back-button {
    position: absolute;
    left: 30px;
}
.help-modal-large .d-flex-align1 span {
    width: 80px;
}

.help-modal-large .pdfnameList {
    padding-left: 4%;
}
.d-flex {
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ClientSwitchTab.vue